<template>
  <div class="row px-3">
    <div class="col-12 mb-4">
			<span class="back-btn" @click="navigateToPreviousPage()">
				<font-awesome-icon icon="arrow-left" size="sm" />
				Back
			</span>
    </div>

    <div class="col-12">
      <p>
        <span v-html="FORM_LABELS.PREVIEW_INVOICE_SUBMISSION" />
      </p>
      <div class="title-text font-weight-bold">
        Invoice details
      </div>
      <div class="row my-2">
        <div class="col-md-6 col-12 mt-3">
          <div class="form-text">{{FORM_LABELS.COMPANY_AND_CODE_NAME}}</div>
          <div>{{filteredFormData.companyCode}} - {{companyCodeText}}</div>
        </div>
      </div>

      <preview-attachments :filteredFormData="filteredFormData" :viewAttachment="true"/>

      <div class="col-12 px-xl-0 pt-5 noprint">
        <div class="d-flex flex-column align-items-center justify-content-xl-end flex-xl-row">
          <button class="btn-container flat-btn gray-btn close-btn btn mx-2 my-3" @click="navigateToHome" :disabled="isLoading">
            Cancel
          </button>
          <button class="btn-container btn primary-blue-btn flat-btn mt-2 mt-xl-0 ml-xl-2"
                 @click="submitInvoiceSubmissionData(filteredFormData)"
                 :disabled="isLoading">
            Submit
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import cloneDeep from "lodash.clonedeep"
import PaymentFormsMixin from "@/mixins/PaymentFormsMixin";
import api from "@/api"
import CONSTANTS from "@/store/constants";
import PreviewAttachments from "@/components/Payments/PreviewAttachments";

export default {
  name: "PreviewInvoiceSubmission",
  props: {
    formData: String
  },
  mixins: [PaymentFormsMixin],
  components: { PreviewAttachments },
  data() {
    return {
      filteredFormData: {},
      companyCodeText: '',
      formType: CONSTANTS.INVOICE_SUBMISSION_BASED_API_FORM_TYPE
    }
  },
  mounted() {
    this.filterDataForPreviewAndSubmit();
  },
  methods: {
    filterDataForPreviewAndSubmit() {
      this.filteredFormData = cloneDeep(this.$store.getters[this.formData])
      this.companyCodeText = this.filteredFormData.companyCodeText
      delete this.filteredFormData.companyCodeText
      //set requesterEmail to current user email
      this.filteredFormData.requesterEmail = this.currentUser.email
    },
    submitInvoiceSubmissionData(formData) {
      formData = this.removeAttachmentFileSizes(formData)
      this.setIsLoading(true)
      this.setIsFormDataLoaded(false)
      this.setFormValidationErrors([])
      let isAsyncSubmission = false
      api.submitInvoiceSubmissionData(formData).then((resp) => {
        let returnMessages = resp.data.data.submitInvoicePdf.invoiceResponse.returnMessage
        if(returnMessages) {
          if(returnMessages.some(message => message.messageType === CONSTANTS.ERROR_MESSAGE_TYPE)) {
            let userErrors = this.buildMessageString(returnMessages, isAsyncSubmission)
            this.setFormValidationErrors(userErrors)
            this.setIsFormDataLoaded(true)
            this.validateAndSetCurrentTab("InvoiceSubmissionQuestionnaire")
            //Reset invoices dashboard to re-fetch tracker data
            this.setFormattedInvoices([])
          } else {
            let userMessages = this.buildSuccessMessageString(returnMessages)
            this.launchSuccessModal(userMessages,  'Supplier Central - Invoice submission form submit success',this.formType)
            this.setIsInvoicesAndDraftsCached(true)
          }
        } else {
          this.launchFailedModal(CONSTANTS.ERROR_MESSAGE, 'Supplier Central - Invoice submission form api error')
        }
      }).catch(() => {
        this.launchFailedModal(CONSTANTS.ERROR_MESSAGE, 'Supplier Central - Invoice submission form api error')
      }).finally(() => {
        this.setIsLoading(false)
      })
    },
    navigateToPreviousPage() {
        this.setIsFormDataLoaded(true)
        this.$emit('setCurrentTab','InvoiceSubmissionQuestionnaire')
    },
    buildSuccessMessageString() {
      let hasMultipleInvoices = this.filteredFormData.attachments && this.filteredFormData.attachments.length > 1;
      let msgPrefix = hasMultipleInvoices ? "Invoices" : "Invoice" 
      let msg = `${msgPrefix} successfully submitted.`
      return msg;
    },
  }
}
</script>

<style>
.form-text {
  font-weight: bold;
  margin-top: 10px;
}

.title-text {
  padding: 0;
  margin: 8px 0;
}
</style>